import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { TooltipContainer } from './components/TooltipContainer.js';
import { TooltipTrigger } from './components/TooltipTrigger.js';

const TooltipIcon = (_param)=>{
    var { className , iconName ='learn-more' , theme  } = _param, props = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "iconName",
        "theme"
    ]);
    return /*#__PURE__*/ React.createElement(TooltipContainer, {
        className: className,
        theme: theme
    }, /*#__PURE__*/ React.createElement(TooltipTrigger, swcHelpers.extends({
        iconName: iconName
    }, props)));
};

export { TooltipIcon as default };
//# sourceMappingURL=TooltipIcon.js.map
